module.exports = __webpack_public_path__ + "static/media/ИФПМ СО РАН.63a8d3d6.jpg";